import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { CheckCircle, ArrowRight } from "lucide-react";
import "./homeLanding.css";
import homePageImage1 from "../../images/homePageImages/homepageimage1.png";
import homePageImage4 from "../../images/homePageImages/homepageimage4.png";
import homePageImage9 from "../../images/homePageImages/homepageimage9.png";
import PhoneCarousel from "../common/phoneCarousel/PhoneCarousel";
import useReveal from "../common/useReveal";

const HomeLanding = () => {
    const { language } = useContext(CombinedContext);
    const navigate = useNavigate();
    const rootRef = useReveal();

    const t = translations[language].homeLanding;

    return (
        <div className="sf-hl-root" ref={rootRef}>

            {/* ── HERO ── */}
            <section className="sf-hl-hero">
                <div className="sf-hl-hero-grid" aria-hidden="true"></div>
                <div className="sf-hl-hero-inner">
                    <div className="sf-hl-hero-left">
                        {/* <div className="sf-hl-hero-badge">
                            <span className="sf-hl-hero-badge-dot"></span>
                            Sin Fila
                        </div> */}

                        <h1>{t.hero.title}</h1>

                        <p className="sf-hl-hero-sub">{t.hero.subtitle}</p>

                        <div className="sf-hl-hero-actions">
                            <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                                {t.hero.primaryCta}
                                <ArrowRight size={17} className="sf-hl-btn-arrow" />
                            </button>
                            <button className="sf-hl-btn-ghost" onClick={() => navigate("/barbershop")}>
                                {t.hero.secondaryCta}
                            </button>
                        </div>

                        <div className="sf-hl-hero-notes">
                            <p className="sf-hl-hero-note">
                                <em>
                                    <strong>{t.hero.freeTrial}</strong>
                                    {t.hero.freeTrialText}
                                </em>
                            </p>

                            <p className="sf-hl-hero-note">
                                <em>
                                    <strong>{t.hero.platformStrong}</strong>
                                    {t.hero.platformRest}
                                </em>
                            </p>
                        </div>
                    </div>

                    <div className="sf-hl-hero-img-wrap">
                        <img src={homePageImage9} alt="" className="sf-hl-hero-img" />
                    </div>
                </div>
            </section>

            {/* ── PAGE BODY ── */}
            <div className="sf-hl-page">

                {/* DOMINICAN COMPANY */}
                <section className="sf-hl-dominican sf-hl-cream-bg">
                    <div className="sf-hl-dominican-inner" data-reveal>
                        <span className="sf-hl-dominican-eyebrow">{t.dominican.eyebrow}</span>
                        <h2>{t.dominican.title}</h2>
                        <p>{t.dominican.paragraph1}</p>
                        <p>{t.dominican.paragraph2}</p>
                        <Link to="/about" className="sf-hl-dominican-link">
                            {t.dominican.linkText}
                            <ArrowRight size={16} />
                        </Link>
                    </div>
                </section>

                {/* WHAT WE DO + PHONE CAROUSEL */}
                <section className="sf-hl-what">
                    <div className="sf-hl-section-head-left" data-reveal>
                        <h2>{t.whatWeDo.title}</h2>
                        <p className="sf-hl-section-sub">{t.whatWeDo.description}</p>
                    </div>

                    <div className="sf-hl-what-grid">
                        <ul className="sf-hl-steps">
                            {t.businessPoints.map((p, i) => (
                                <li key={i} className="sf-hl-step-item" data-reveal>
                                    <div className="sf-hl-step-num">{i + 1}</div>
                                    <div className="sf-hl-step-content">
                                        <strong>{p.title}</strong>
                                        <p>{p.desc}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        <div className="sf-hl-phone-wrap" data-reveal>
                            <div className="sf-hl-phone-glow"></div>
                            <PhoneCarousel />
                        </div>
                    </div>
                </section>

                {/* BENEFITS — BUSINESS: image LEFT, card RIGHT */}
                <section className="sf-hl-benefits-section sf-hl-dyk-bg">
                    <div className="sf-hl-benefits-inner">
                        <div className="sf-hl-benefits-img-wrap" data-reveal>
                            <img src={homePageImage1} alt="" className="sf-hl-benefits-img" />
                        </div>

                        <div className="sf-hl-benefits-card" data-reveal>
                            <h3>{t.business.title}</h3>
                            <p className="sf-hl-benefits-intro">{t.business.intro}</p>

                            <ul className="sf-hl-checklist">
                                {t.business.items.map((item, idx) => (
                                    <li key={idx}>
                                        <CheckCircle size={16} className="sf-hl-check-icon" />
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                                {t.business.cta}
                                <ArrowRight size={17} className="sf-hl-btn-arrow" />
                            </button>
                        </div>
                    </div>
                </section>

                {/* BENEFITS — CLIENTS: card LEFT, image RIGHT */}
                <section className="sf-hl-benefits-section">
                    <div className="sf-hl-benefits-inner">
                        <div className="sf-hl-benefits-card" data-reveal>
                            <h3>{t.clients.title}</h3>
                            <p className="sf-hl-benefits-intro">{t.clients.intro}</p>

                            <ul className="sf-hl-checklist">
                                {t.clients.items.map((item, idx) => (
                                    <li key={idx}>
                                        <CheckCircle size={16} className="sf-hl-check-icon" />
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <button className="sf-hl-btn-ghost-dark" onClick={() => navigate("/barbershop")}>
                                {t.clients.cta}
                                <ArrowRight size={16} />
                            </button>
                        </div>

                        <div className="sf-hl-benefits-img-wrap" data-reveal>
                            <img src={homePageImage4} alt="" className="sf-hl-benefits-img" />
                        </div>
                    </div>
                </section>

                {/* HOW IT WORKS */}
                <section className="sf-hl-how sf-hl-cream-bg">
                    <div className="sf-hl-section-head-center" data-reveal>
                        <h2>{t.about.title}</h2>
                    </div>

                    <div className="sf-hl-how-grid">
                        <div className="sf-hl-how-step" data-reveal>
                            <div className="sf-hl-how-circle">
                                <strong>{t.about.step1}</strong>
                                <span>{t.about.step1Text}</span>
                            </div>
                            <p>{t.about.paragraph1}</p>
                        </div>

                        <div className="sf-hl-how-connector" aria-hidden="true"></div>

                        <div className="sf-hl-how-step" data-reveal>
                            <div className="sf-hl-how-circle">
                                <strong>{t.about.step2}</strong>
                                <span>{t.about.step2Text}</span>
                            </div>
                            <p>{t.about.paragraph2}</p>
                        </div>

                        <div className="sf-hl-how-connector" aria-hidden="true"></div>

                        <div className="sf-hl-how-step" data-reveal>
                            <div className="sf-hl-how-circle">
                                <strong>{t.about.step3}</strong>
                                <span>{t.about.step3Text}</span>
                            </div>
                            <p>{t.about.paragraph3}</p>
                        </div>
                    </div>
                </section>

                {/* FINAL CTA */}
                <section className="sf-hl-final" data-reveal>
                    <p>{t.finalCta.text}</p>
                    <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                        {t.business.cta}
                        <ArrowRight size={17} className="sf-hl-btn-arrow" />
                    </button>
                </section>

                {/* TESTIMONIALS */}
                <section className="sf-hl-testimonials">
                    <div className="sf-hl-section-head-center" data-reveal>
                        <h2>{t.testimonials.title}</h2>
                    </div>
                    <div className="sf-hl-testimonial-grid">
                        {t.testimonials.items.map((item, i) => (
                            <div className="sf-hl-testimonial-card" key={i} data-reveal>
                                <span className="sf-hl-testimonial-mark" aria-hidden="true">&ldquo;</span>
                                <p className="sf-hl-testimonial-quote">“{item.quote}”</p>
                                <div className="sf-hl-testimonial-author">
                                    <div className="sf-hl-testimonial-avatar" aria-hidden="true">
                                        {item.name.charAt(0)}
                                    </div>
                                    <div>
                                        <strong>{item.name}</strong>
                                        <span>{item.role}, {item.location}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
        </div>
    );
};

export default HomeLanding;
